import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
 apiKey: "AIzaSyBmeWIQ1FEDIeh8shnD5yVa7uXGfJT42Q0",
  authDomain: "gis-attendance-f6c83.firebaseapp.com",
  projectId: "gis-attendance-f6c83",
  storageBucket: "gis-attendance-f6c83.firebasestorage.app",
  messagingSenderId: "643083230089",
  appId: "1:643083230089:web:79b4688b3b5a7500445f58",
  measurementId: "G-6L559CZMJ0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth();
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;